import { render, staticRenderFns } from "./TheArtworks.vue?vue&type=template&id=1d83c12a&scoped=true&"
import script from "./TheArtworks.vue?vue&type=script&lang=js&"
export * from "./TheArtworks.vue?vue&type=script&lang=js&"
import style0 from "./TheArtworks.vue?vue&type=style&index=0&id=1d83c12a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d83c12a",
  null
  
)

export default component.exports